import React from "react";
import { Route, Routes } from "react-router-dom";
import DeleteAccount from "../Components/Component/DeleteAccount";

const DeleteRoute = () => {
  return (
    <Routes>
      <Route index element={<DeleteAccount />} />
      <Route path="/deleteAccount" element={<DeleteAccount />} />
    </Routes>
  );
};

export default DeleteRoute;
